import React from 'react';
import Autosuggest from '../../../components/Fields/autosuggest';
import connect from 'react-redux/es/connect/connect';
const HeroSection = ({courses}) => {
  return (
    <div className="hero-container">
      <div className="hero-text-container">
        <div className="hero-title1">10% Off</div>
        <div className="hero-title2">Your Online CMI Course Fees</div>
        <div className="hero-text">
          <p>Improve your professional qualifications.</p>
          <p>
            <strong>Management, Leadership </strong> and{' '}
            <strong>Business online</strong>
          </p>
          <p>distance learning <strong>
            courses.
            </strong> 
            </p>

          <p className='hero-discount-code'>Use Code: <q>
            <strong>CMI10</strong>
            </q>
            </p>

          <button className="hero-button" onClick={() => window.location.href = '/courses'} style={{ cursor: 'pointer', marginTop: '1rem', zIndex: 997, position: 'relative'  }}>
            <div className="hero-button-content">
            <p>View All Courses</p>
            <img src="/images/icons/click.svg" alt="arrow"/>
            </div>
            </button>
        </div>
      </div>
      <div className=""></div>
      <div className="hero-image">
      <div className='hero-search-bar'>
        <div style={{ width: '100%' }}>
        <Autosuggest suggestions={courses} />
        <a className="allCoursesButtonMobile" href="/courses">
          or <span style={{ fontWeight: 700 }}>browse all courses</span>
        </a>
        </div>
        <div className='not-search-wrapper'>
        <a className="allCoursesButton" href="/courses">
          or <span style={{ fontWeight: 700 }}>browse all courses</span>
        </a>
        <div className="logo-container">
          <img src="/images/logos/cmi-small.svg" alt="cmi logo"/>
        </div>
        </div>
      </div>
      </div>
      <div className="hero-search-mobile">
      <div style={{ width: '100%' }}>
        <Autosuggest suggestions={courses} />
        </div>
        <div className='not-search-wrapper-mobile'>
        <a className="allCoursesButton" href="/courses" style={{display: 'flex', justifyContent: 'center'}}>
          or <span style={{ fontWeight: 700 }}>&nbsp;browse all courses</span>
        </a>
        </div>
        <div className="logo-container-mobile">
          <img src="/images/logos/cmi-small.svg" alt="cmi logo" style={{height: "40px", weight: "88px"}}/>
        </div>

        
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  courses: state.courses.courses
});

export default connect(mapStateToProps)(HeroSection);
;
